// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck — @dnd-kit types incompatible with @types/react@19
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable'
import type { SortingStrategy } from '@dnd-kit/sortable'

interface Props {
  items: string[]
  strategy?: SortingStrategy
  children: React.ReactNode
}

export default function SortableContextWrapper({
  items,
  strategy = rectSortingStrategy,
  children
}: Props) {
  return (
    <SortableContext items={items} strategy={strategy}>
      {children}
    </SortableContext>
  )
}
